<script>
import {defineComponent} from 'vue'
import PopularProductBannerItem from "@js/components/Sections/Home/Components/PopularProductBannerItem.vue";
import img_1 from '@img/popular_banners/1.webp'
import img_2 from '@img/popular_banners/2.webp'
import img_3 from '@img/popular_banners/3.webp'
import img_4 from '@img/popular_banners/4.webp'
import img_5 from '@img/popular_banners/5.webp'
import img_6 from '@img/popular_banners/6.webp'

export default defineComponent({
    name: "PopularProductBanners",
    components: {PopularProductBannerItem},
    setup() {
        return {img_1, img_2, img_3, img_4, img_5, img_6}
    }
})
</script>

<template>
    <div class="grid grid-cols-1 gap-5">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
            <div class="grid grid-cols-1">
                <PopularProductBannerItem title="Плитка для ванной"
                                          description="Оформите ванную в своем стиле — уютно и со вкусом"
                                          :img="img_1"
                                          :link="route('catalog', {category_title: 'plitka', rooms: JSON.stringify([1])})"/>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <PopularProductBannerItem title="Плитка для кухни"
                                          description="Уют и стиль на вашей кухне"
                                          :img="img_2"
                                          :link="route('catalog', {category_title: 'plitka', rooms: JSON.stringify([3])})"/>
                <PopularProductBannerItem title="Мозаика в ванну"
                                          description="Яркий штрих для интерьера"
                                          :img="img_3"
                                          :link="route('catalog', {category_title: 'mozaika', rooms: JSON.stringify([1])})"/>
            </div>
        </div>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <PopularProductBannerItem title="Искусственный камень для фасада"
                                          description="Прочность и изящество"
                                          :img="img_4"
                                          :link="route('catalog', {category_title: 'iskustvenniy_kamen', rooms: JSON.stringify([14])})"/>
                <PopularProductBannerItem title="Ступени из природного камня"
                                          description="Надёжно и красиво"
                                          :img="img_5"
                                          :link="route('catalog', {category_title: 'stupeni', surfaces: JSON.stringify([10])})"/>
            </div>
            <div class="grid grid-cols-1">
                <PopularProductBannerItem title="Керамогранит для кухни"
                                          description="Мраморный стиль с прочностью керамогранита"
                                          :img="img_6"
                                          :link="route('catalog', {category_title: 'keramogranit', rooms: JSON.stringify([3])})"/>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
